import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { addDaysToDate, formatDate, formatMoney, getCurrentDateForInput, getInlineLoader, remove255 } from "../Helpers";
import {
	STR_AVAILABLE_HOTELS,
	STR_AVAILABLE_ROOMS,
	STR_BOOK_NOW,
	STR_BOOK_THIS_ROOM,
	STR_CHANGE_PHONE_NUMBER,
	STR_CHECK_IN_DATE,
	STR_CHECK_OUT_DATE,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_ENTER_PHONE_NUMBER_FOR_PAYMENT,
	STR_FINALIZE_PAYMENT_CARD,
	STR_FINALIZE_PAYMENT_MOBILE,
	STR_GO_BACK,
	STR_INVALID_CHECK_IN_DATE,
	STR_INVALID_NUMBER_OF_DAYS,
	STR_INVALID_PAYWITH,
	STR_MENU_HOTELS,
	STR_NO_RECORD,
	STR_NOTIFICATIONS,
	STR_NUMBER_OF_DAYS,
	STR_OVERALL_COST,
	STR_PAY_WITH_CARD,
	STR_PAY_WITH_MOBILE,
	STR_PAYMENT_SETTINGS,
	STR_PER_DAY,
	STR_PERSONAL_SETTINGS,
	STR_ROOM,
	STR_STARTING_FROM_DATE,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_TOTAL_ORDER_PRICE,
	STR_TRANSACTION_FEEs,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_DAYS,
	STR_DAY,
	STR_BOOKING_DATE,
	STR_VIEW_HOTEL,
	STR_VIEW_ROOM,
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdCheckCircle, MdContactPage, MdHotel, MdInfoOutline, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdRoom, MdSupportAgent, MdTranslate } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import OneRoomOrder from '../ones/OneRoomOrder';
import ImagesSlider from "../ones/ImagesSlider";
import { CDN_URL, callApi } from "../Helpers";
import MobileInterface from "../MobileInterface";
import { TbBrandDaysCounter } from "react-icons/tb";
import RoomOrderReceipt from "../ones/RoomOrderReceipt";

export default function View({ id }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [data, setData] = useState(null);
	const [customerData, setCustomerData] = useState(null);
	
	const [opSuccessful, setOpSuccessful] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			getData(),
		]);
		setReady(true);
	}


	async function getData() {
		await callApi('get-room-order-data', { id }).then(async (response) => {
			if(response.status === 1) {
				setData(response.data)
				await getCustomerData(response.data.userId);
			} else {
				appContext.tellError('Could not fetch data, check network')
			}
		})
	}

	async function getCustomerData(customerId) {
		await callApi('get-user-data', { id: customerId }).then((response) => {
			if(response.status === 1) {
				setCustomerData(response.data)
			} else {
				appContext.tellError('Could not fetch data, check network')
			}
		})
	}
	
	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready && data && customerData) {
		return (	
			<div className="container">	
				<div className="row">
					<div className="col-md-12">

						<OneRoomOrder data={data}/>

					</div>

					<div className="col-6">
						<label className="form-label">{STR_CHECK_IN_DATE[appContext.language]}</label>
						<h6
							style={{
								fontSize: "16px"
							}}
						>
							{data.checkInDate}
						</h6>
					</div>

					<div className="col-6 text-end">
						<label className="form-label">{STR_CHECK_OUT_DATE[appContext.language]}</label>
						<h6
							style={{
								fontSize: "16px"
							}}
						>
							{data.checkOutDate}
						</h6>
					</div>

					<div className="col-12 mt-2 mb-2">
						<hr/>
						<RoomOrderReceipt customerData={customerData} data={data}/>
						<hr/>
					</div>

					<div className="col-12 mt-2 mb-2">
						<button
							className="btn btn-block btn-rounded btn-padded btn-surface text-primary mShadow1 mb-3"
							onClick={() => {
								appContext.navTo({
									item: 'side-view',
									subItem: 'hotel',
									extraItem: data.hotelId,
								})
							}}
						>
							{STR_VIEW_HOTEL[appContext.language]}
						</button>

						<button
							className="btn btn-block btn-rounded btn-padded btn-primary mb-3 mt-3"
							onClick={() => {
								appContext.navTo({
									item: 'side-view',
									subItem: 'hotel-room',
									extraItem: data.hotelRoomId,
								})
							}}
						>
							{STR_VIEW_ROOM[appContext.language]}
						</button>
					</div>
					
				</div>
			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}